import { useContext, useEffect } from 'react'
import { UserContext } from '../../contexts/user-context'
import * as Preferences from '../../constants/USER_PREFERENCE'
import UserPreferenceControl from './UserPreferenceControl'
import LoadingSpinner from '../ui/LoadingSpinner'

const UserPreferences = () => {
    const { user, ddUser, userPreferences, getUserPreferences } = useContext(UserContext)

    const handlePreferenceSaved = () => {
        getUserPreferences()
    }

    useEffect(() => {
        if (user && ddUser && !userPreferences) {
            getUserPreferences()
        }
    }, [user, ddUser, userPreferences])

    return userPreferences ? (
        <div className="spc-m-t-2">
            <table className="table-default">
                <thead>
                    <tr>
                        <th colSpan={2}>
                            My Preferences
                        </th>
                    </tr>
                </thead>

                <tbody>
                {Preferences.PREFERENCES.map(preferenceKey => {
                    const userPreference = userPreferences.find(
                        pref => Object.keys(pref)[0] === preferenceKey
                    )

                    return (
                        <tr key={preferenceKey}>
                            <td>
                                <h5 className="spc-m-t-0 spc-m-b-half">{Preferences.PREF_LABEL[preferenceKey]}</h5>
                                <p className="spc-m-t-0 spc-m-b-0" style={{
                                    fontSize: '0.8rem',
                                    fontWeight: '300',
                                    color: '#555'
                                }}>
                                    {Preferences.PREF_DESCRIPTION[preferenceKey]}
                                </p>
                            </td>

                            <td>
                                <UserPreferenceControl
                                    userPreference={userPreference}
                                    preferenceKey={preferenceKey}
                                    onSave={handlePreferenceSaved}
                                />
                            </td>
                        </tr>
                    )
                })}
                </tbody>
            </table>
        </div>
    ) : (
        <LoadingSpinner />
    )
}

export default UserPreferences;

